import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import { LogChange } from "../types/logs/change.type";
import { formatDateTime } from "../utils/formatters";
import ChangesColumn from "../components/LogChangesTable/components/ChangesColumn";
import Button from "../components/Button";

export class LogChangesTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (logChanges: LogChange[]) => {
      return logChanges.map((log) => ({
        ...log,
        created_at: formatDateTime(new Date(log.created_at)),
        full_name: log?.request?.performed_by?.full_name ? log.request.performed_by.full_name : undefined,
        description: (
          <p className="line-clamp-3 whitespace-normal">
            {log?.request?.operation_description ? log.request.operation_description : undefined}
          </p>
        ),
        item_name_translated: log.item_name_translated,
        changes: <ChangesColumn id={log.id} changes={log.object_changes_translated} />,
        changes_before: <ChangesColumn id={log.id} changes={log.object_changes_translated} col="changes_before" />,
        changes_after: <ChangesColumn id={log.id} changes={log.object_changes_translated} col="changes_after" />,
        actions: log.request_id && (
          <Link to={log.request_id}>
            <Button className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
              <ArrowBigRight />
            </Button>
          </Link>
        )
      }));
    };
  }
}
